import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Film } from "lucide-react";
import { api } from "@/lib/api";
import { Breadcrumbs } from "@/components/ui/Breadcrumbs";
import { MatchTimelineContent } from "@/components/MatchDetailModal";
import type { FinishedMatchWithResultado } from "@/components/MatchDetailModal";

// Ficha de un partido jugado para móvil: mismo contenido que el popup de escritorio
// (MatchDetailModal), pero como página entera con su propia URL — en pantallas estrechas un
// popup con vídeo + marcador lado a lado no cabe bien, así que aquí se apila todo en vertical.
export function MatchDetailPage() {
  const { id } = useParams();
  const matchId = Number(id);

  const { data: match, isLoading } = useQuery({
    queryKey: ["matches", "finished", matchId],
    queryFn: async () => (await api.get<FinishedMatchWithResultado>(`/matches/finished/${matchId}`)).data,
  });

  if (isLoading || !match) {
    return <p className="text-sm text-ink-400">Cargando partido…</p>;
  }

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumbs items={[{ label: "Partidos", to: "/partidos" }, { label: "Jugados", to: "/partidos" }, { label: match.customerName }]} />

      <div className="flex items-center gap-4">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-50 text-violet-600">
          <Film className="h-6 w-6" />
        </span>
        <div>
          <h1 className="text-2xl font-bold text-ink-900">{match.court?.name ?? match.courtLabel}</h1>
          <p className="text-ink-400">
            {match.club.nombre} · {match.customerName}
          </p>
        </div>
      </div>

      <MatchTimelineContent matchId={match.id} />
    </div>
  );
}
